 $(document).ready(function() {
     $('input[type="tel"]').mask('+7 999 999-9999', { autoclear: false }, { placeholder: '+7             ' });

     $(".fg select").niceSelect()

     $('#turntable').turntable({
         axis: 'x'
     });

     fix100vh();
     window.addEventListener('resize', () => {
         fix100vh();
     })

     new AirDatepicker('.date-input', {
         locale: localeRu,
         // inline: true,
         // isMobile: true,
         autoClose: true,
         onSelect: () => {
             $(".date-input").addClass("input-active")
         }
     })
 });

 function fix100vh() {
     let vh = window.innerHeight * 0.01;
     document.documentElement.style.setProperty('--vh', `${vh}px`);
 }